// Backend proxs URL
export const PROXY_URL = process.env.REACT_APP_BASE_URL

export const FETCH_ALL_PRODUCTS = "FETCH_ALL_PRODUCTS";
export const FETCH_ALL_CATEGORIES = "FETCH_ALL_CATEGORIES";
export const FETCH_ALL_SHOPS = "FETCH_ALL_SHOPS";
export const FETCH_ALL_BRANDS = "FETCH_ALL_BRANDS";
export const FETCH_ONEPRODUCT = "FETCH_ONEPRODUCT";
export const FETCH_SIMILAR_PRODUCTS = "FETCH_SIMILAR_PRODUCTS";
export const GET_FAVORITE_PRODUCTS = "GET_FAVORITE_PRODUCTS";
export const GET_CART_PRODUCTS = "GET_CART_PRODUCTS";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const EDIT_PRODUCT = "EDIT_PRODUCT";
export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const EDIT_CATEGORY = "EDIT_CATEGORY";
export const CREATE_SHOP = "CREATE_SHOP";
export const EDIT_SHOP = "EDIT_SHOP";   
export const DELETE_SHOP = "DELETE_SHOP";
export const CREATE_BRAND = "CREATE_BRAND";
export const EDIT_BRAND = "EDIT_BRAND";
export const DELETE_BRAND = "DELETE_BRAND";
export const FETCH_ADMINS = "FETCH_ADMINS";
export const CREATE_ADMIN = "CREATE_ADMIN";
export const EDIT_ADMIN = "EDIT_ADMIN";
export const DELETE_ADMIN = "DELETE_ADMIN";
export const AUTH_LOGIN = "AUTH_LOGIN";
export const GET_SLIDERS = "GET_SLIDERS";
export const CREATE_SLIDER = "CREATE_SLIDER";
export const EDIT_SLIDER = "EDIT_SLIDER";
export const DELETE_SLIDER = "DELETE_SLIDER";
export const GET_BANNERS = "GET_BANNERS";
export const CREATE_BANNER = "CREATE_BANNER";
export const EDIT_BANNER = "EDIT_BANNER";
export const DELETE_BANNER = "DELETE_BANNER";
export const GET_BUYS = "GET_BUYS";
export const CREATE_BUY = "CREATE_BUY";
export const EDIT_BUY = "EDIT_BUY";
export const DELETE_BUY = "DELETE_BUY";
